/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * Data for the Gather view line "Request sent …, opened …, Family 7 of 9 complete, next reminder …"
 * @export
 * @interface OutreachSummary
 */
export interface OutreachSummary {
    /**
     * 
     */
    first_sent_at: Date | null;
    /**
     * 
     */
    last_sent_at: Date | null;
    /**
     * 
     */
    first_opened_at: Date | null;
    /**
     * 
     */
    participant_item_count: number;
    /**
     * 
     */
    participant_item_complete_count: number;
    /**
     * 
     */
    next_reminder_at: Date | null;
}

/**
 * Check if a given object implements the OutreachSummary interface.
 */
export function instanceOfOutreachSummary(value: object): value is OutreachSummary {
    if (!('first_sent_at' in value) || value['first_sent_at'] === undefined) return false;
    if (!('last_sent_at' in value) || value['last_sent_at'] === undefined) return false;
    if (!('first_opened_at' in value) || value['first_opened_at'] === undefined) return false;
    if (!('participant_item_count' in value) || value['participant_item_count'] === undefined) return false;
    if (!('participant_item_complete_count' in value) || value['participant_item_complete_count'] === undefined) return false;
    if (!('next_reminder_at' in value) || value['next_reminder_at'] === undefined) return false;
    return true;
}

export function OutreachSummaryFromJSON(json: any): OutreachSummary {
    return OutreachSummaryFromJSONTyped(json, false);
}

export function OutreachSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutreachSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'first_sent_at': (json['first_sent_at'] == null ? null : parseDateTime(json['first_sent_at'])),
        'last_sent_at': (json['last_sent_at'] == null ? null : parseDateTime(json['last_sent_at'])),
        'first_opened_at': (json['first_opened_at'] == null ? null : parseDateTime(json['first_opened_at'])),
        'participant_item_count': json['participant_item_count'],
        'participant_item_complete_count': json['participant_item_complete_count'],
        'next_reminder_at': (json['next_reminder_at'] == null ? null : parseDateTime(json['next_reminder_at'])),
    };
}

export function OutreachSummaryToJSON(json: any): OutreachSummary {
    return OutreachSummaryToJSONTyped(json, false);
}

export function OutreachSummaryToJSONTyped(value?: OutreachSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_sent_at': value['first_sent_at'] == null ? value['first_sent_at'] : serializeDateTime(value['first_sent_at']),
        'last_sent_at': value['last_sent_at'] == null ? value['last_sent_at'] : serializeDateTime(value['last_sent_at']),
        'first_opened_at': value['first_opened_at'] == null ? value['first_opened_at'] : serializeDateTime(value['first_opened_at']),
        'participant_item_count': value['participant_item_count'],
        'participant_item_complete_count': value['participant_item_complete_count'],
        'next_reminder_at': value['next_reminder_at'] == null ? value['next_reminder_at'] : serializeDateTime(value['next_reminder_at']),
    };
}

